var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessibility({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C5.83158 0 0 5.83158 0 13C0 20.1684 5.83158 26 13 26C20.1684 26 26 20.1684 26 13C26 5.83158 20.1684 0 13 0ZM13 2.16667C18.9963 2.16667 23.8333 7.00375 23.8333 13C23.8333 18.9963 18.9963 23.8333 13 23.8333C7.00375 23.8333 2.16667 18.9963 2.16667 13C2.16667 7.00375 7.00375 2.16667 13 2.16667ZM13 4.33333C12.4254 4.33333 11.8743 4.56161 11.4679 4.96794C11.0616 5.37426 10.8333 5.92536 10.8333 6.5C10.8333 7.07464 11.0616 7.62574 11.4679 8.03206C11.8743 8.43839 12.4254 8.66667 13 8.66667C13.5746 8.66667 14.1257 8.43839 14.5321 8.03206C14.9384 7.62574 15.1667 7.07464 15.1667 6.5C15.1667 5.92536 14.9384 5.37426 14.5321 4.96794C14.1257 4.56161 13.5746 4.33333 13 4.33333ZM6.73725 8.70025L6.26167 10.8008L10.8322 11.8159V16.25L9.7825 21.4641L11.882 21.8703L12.9653 16.4537L12.9989 16.3518L13.0325 16.4526L14.1158 21.8693L16.2153 21.463L15.1667 16.25V11.8148L19.7373 10.7998L19.2628 8.70025L14.625 9.75H11.375L6.73725 8.70025Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibility);
export default __webpack_public_path__ + "static/media/accessibility.dcbc131ea3737e70c60b63b693abf3be.svg";
export { ForwardRef as ReactComponent };